// Small list of a task's still-pending (not yet fired) reminders, with a
// cancel action. Shared between TaskModal (project tasks) and Lists.tsx'
// DetailPanel (personal tasks) — the two places that can create a reminder.

import { Bell, X } from "lucide-preact";
import { useReminders, cancelReminder } from "../store/reminders";
import { formatDateTimeShort } from "../lib/format";

interface Props {
  taskId?: number;
  personalTaskId?: number;
}

export function PendingReminders(props: Props): preact.JSX.Element | null {
  const { reminders } = useReminders();
  const mine = reminders.filter((r) =>
    props.taskId !== undefined ? r.task_id === props.taskId : r.personal_task_id === props.personalTaskId
  );

  if (mine.length === 0) return null;

  return (
    <ul class="flex flex-col gap-1 mt-1">
      {mine.map((r) => (
        <li
          key={r.id}
          class="flex items-center gap-1.5 rounded border border-[color:var(--color-outline-variant)] bg-[color:var(--color-surface-container-low)] px-2 py-1 text-xs text-[color:var(--color-on-surface)]"
        >
          <Bell size={14} class="shrink-0 text-[color:var(--color-on-surface-variant)]" aria-hidden="true" />
          <span class="flex-1 min-w-0 truncate">{formatDateTimeShort(r.remind_at)}</span>
          <button
            type="button"
            onClick={() =>
              // api() toastet PATCH-Fehler bereits selbst; hier nur die
              // unbehandelte Ablehnung abschliessen (keine lokale
              // optimistische Liste, die zurückgerollt werden müsste — die
              // Reminder-Liste kommt erst nach Erfolg aus dem Store).
              void cancelReminder(r.id).catch(() => {
                /* api() toastet bereits */
              })
            }
            class="shrink-0 rounded p-0.5 text-[color:var(--color-on-surface-variant)] hover:bg-[color:var(--color-surface-container-lowest)] hover:text-[color:var(--color-error)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-primary)]"
            aria-label="Erinnerung entfernen"
            title="Erinnerung entfernen"
          >
            <X size={14} aria-hidden="true" />
          </button>
        </li>
      ))}
    </ul>
  );
}
